import PropTypes from 'prop-types';
import { IconButton } from '@mui/material';
import { MIcon } from '../../../../@material-extend';

/**
 * Provides a button specifically for closing UI elements like modals or snackbars.
 * This component uses an icon button with a clear (X) icon.
 *
 * @param {Object} props The component props.
 * @param {string} props.color The color prop adjusts the color of the IconButton component.
 * @param {Function} props.handleClick The function to call when the button is clicked, typically used to close/hide a UI element.
 * @returns {JSX.Element} A Material-UI IconButton configured with a clear icon.
 */
const CloseButton = ({ handleClick }) => (
  <IconButton id="close-snackbar" onClick={handleClick}>
    <MIcon icon="close" variant="white" fontSize={20} />
  </IconButton>
);

CloseButton.propTypes = {
  handleClick: PropTypes.func.isRequired
};

export default CloseButton;
